import {SET_EMPLOYMENT_FORM, SET_LOADING} from "./mutation_types";


export default {
    [SET_EMPLOYMENT_FORM](state, resource) {
        state.employmentForm = resource.data;
    },
    [SET_LOADING](state, loading) {
        state.loading = loading;
    },
}